"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _CampaignLoader = _interopRequireDefault(require("./CampaignLoader"));

var _Campaign = _interopRequireDefault(require("./Campaign"));

require("../styles/_campaigns.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function handleClick(history, inspirationCampaignId) {
  return function () {
    history.push("/manage/campaigns/".concat(inspirationCampaignId));
  };
}

function Campaigns(_ref) {
  var campaigns = _ref.campaigns,
      history = _ref.history;

  if (!campaigns) {
    return _react.default.createElement(_CampaignLoader.default, null);
  }

  return _react.default.createElement("div", {
    className: "campaigns"
  }, !campaigns.length ? _react.default.createElement(_uiKit.Text, {
    heading4: true
  }, 'Create your first Campaign by clicking the \'New Campaign\' button above.') : null, campaigns.map(function (_ref2) {
    var inspirationCampaignId = _ref2.inspirationCampaignId,
        coverImageKey = _ref2.coverImageKey,
        name = _ref2.name,
        updatedAt = _ref2.updatedAt,
        organisationId = _ref2.organisationId;
    return _react.default.createElement(_Campaign.default, {
      key: inspirationCampaignId,
      inspirationCampaignId: inspirationCampaignId,
      imageUrl: coverImageKey,
      name: name,
      onClick: handleClick(history, inspirationCampaignId),
      updatedAt: updatedAt,
      organisationId: organisationId
    });
  }));
}

var _default = (0, _react.memo)(Campaigns);

exports.default = _default;